<template>
    <div class="fd-content-more">
        <!--面包屑-->
        <crumbs-nav :dataList="crumbsList"></crumbs-nav>
<!--      学习新时代table -->
        <div class="fd-more-content">
            <aty-form
                      class="fd-search-content fd-mt17"
                      @submit.native.prevent
                      @keydown.native.enter="searchButton">
                <div class="fd-search-col">
                    <aty-input class="fd-input-01"
                               label="标题"
                               maxlength="80"
                               placeholder="请输入"
                               :label-width="50"
                               v-model.trim="query.title"
                    ></aty-input>
                </div>
                <div class="fd-search-col">
                    <aty-date-picker class="fd-date-picker-01"
                                     label="发布日期"
                                     :label-width="90"
                                     placeholder="开始日期      -       结束日期"
                                     type="daterange"
                                     :transfer="true"
                                     v-model="query.fbrq"
                    ></aty-date-picker>
                </div>
                <div class="fd-search-col">
                    <aty-button class="fd-ml18" type="primary" text="查询" @click="searchButton"></aty-button>
                    <aty-button type="default" text="重置" @click="handleReset"></aty-button>
                </div>
            </aty-form>
            <ul class="fd-table-list fd-mt24" v-if="data && data.data && data.data.length">
                <li class="fd-table-header">
                    <div>标题</div>
                    <div>发布日期</div>
                </li>
                <li class="fd-table-item" v-for="(item, index) in data.data"
                    :key="index"
                    @click="handleToDetail(item)"
                >
                    <div  :title="item.bt">
                        {{ item.bt }}
                    </div>
                    <div v-if="tab === 'alfx'" :title="item.zcjg">{{ item.zcjg }}</div>
                    <div class="fd-date">{{ dateFormat(item.fbsj, 'yyyy-MM-dd') }}</div>
                </li>
            </ul>
            <div class="fd-no-data" v-else-if="data && data.data && !data.data.length">
                <p>很抱歉，您浏览的页面暂无数据展示</p>
                <div class="fd-small-data">
                    <p>温馨提示：</p>
                    <p>1.内容正在维护更新中</p>
                    <p>2.您可以浏览其他板块页面</p>
                </div>
            </div>
            <aty-pagination class="fd-pagination"
                            :total="data.total"
                            v-if="data.data&&data.data.length"
                            :limit="data.limit"
                            :offset="data.offset"
                            show-total
                            show-elevator
                            @change="pageInformation"
            ></aty-pagination>
        </div>
    </div>
</template>

<script>
import ccTab from '@/components/common/tab/index.vue';
export default {
    name: 'index',
    components:{ccTab},
    data() {
        return {
            // 面包屑的数据
            crumbsList:[{
                name:'学习新时代',
                key:'xxxsd'
            }],
            // 查询组件数据
            query: {
                title: null,
                fbdw: null,
                ejlb: null,
                xwbt: null,
                fbrq: null,
                zcjg: null,
                fbfy: null
            },
            // 表格数据
            data: {
                offset: 0,
                limit: 10,
                total: null,
                data: [{bt:''}]
            }
        };
    },
    created() {
        // 请求表格数据
        this.handleSearch();
    },
    methods:{
        searchButton() {
            this.query.limit = 10;
            this.query.offset = 0;
            this.handleSearch();
        },
        pageInformation(pageInfo) {
            this.query.limit = pageInfo.limit;
            this.query.offset = pageInfo.offset;
            this.handleSearch();
        },
        // 重置
        handleReset() {
            this.query = {
                title: null,
                fbrq: null
            };
            this.handleSearch();
        },
        // 请求表格数据
        handleSearch() {
            const queryParams = {
                xwlb: '13',
                bt: this.query.title,
                limit: this.query.limit,
                offset: this.query.offset
            };
            if (this.query.fbrq && this.query.fbrq.length > 0) {
                queryParams.fbsjFrom = `${this.query.fbrq[0]} 00:00:00`;
                queryParams.fbsjTo = `${this.query.fbrq[1]} 23:59:59`;
            } else {
                queryParams.fbsjFrom = null;
                queryParams.fbsjTo = null;
            }
            const url = window.fdConfig.url.xwzx.latestXwzxPage;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: url,
                params: queryParams
            })
                .then((res) => {
                    if (res.data) {
                        this.data = res.data;
                    }
                });
        },
        handleToDetail(item) {
            const url = this.$router.resolve({path: '/xwzxDetail', query: {active: this.active, bh: item.bh, fileType: 25}});
            window.open(url.href, '_blank');
        }
    }
};
</script>
